import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

interface PageTitleProps {
  note?: string;
  notePlacement?: 'center' | 'bottom';
}

const PageTitle: FunctionComponent<PageTitleProps> = ({
  note,
  children,
  notePlacement = 'bottom',
}) => {
  return (
    <Flex
      sx={{
        alignItems: 'center',
        columnGap: '16px',
        fontWeight: 600,
        fontSize: '32px',
        lineHeight: 'normal',
        color: 't.black90',
      }}
    >
      <Box as="span">{children}</Box>
      {note && (
        <Box
          as="span"
          sx={{
            alignSelf: notePlacement === 'bottom' ? 'flex-end' : undefined,
            marginBottom: notePlacement === 'bottom' ? '4px' : undefined,
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '14px',
            color: '#666E71',
          }}
        >
          {note}
        </Box>
      )}
    </Flex>
  );
};

export default PageTitle;
